// Blog-specific translations to keep main translation files smaller.
const blogEn = {
  blogs: {
    title: 'Photremium Blog',
    subtitle: 'Advanced AI imaging guides, workflows, and performance tips.',
    searchPlaceholder: 'Search by topic, tool, or keyword...',
    filterAll: 'All',
    filterGuides: 'Guides',
    filterTips: 'Tips',
    filterUpdates: 'Updates',
    sortNewest: 'Newest',
    sortPopular: 'Popular',
    readTime: 'min read',
    ctaTitle: 'Stay in the loop',
    ctaDesc: 'New tutorials and workflows every week.',
  },
  seo: {
    blogsTitle: 'Photremium Blog — AI Image Tools, Guides & Workflows',
    blogsDesc: 'Read Photremium blog posts about AI image editing, performance, compression, and professional workflows.',
    blogsKeywords: 'photremium blog, ai image tools, image compression, background removal, photo editing tips',
  },
};

export default blogEn;
